/* Frontend Masonry grid for Judge.me reviews */
(function () {
  function normalizeApiBase(v) {
    if (!v) return '';
    const u = String(v).trim().replace(/\/+$/, '');
    return /\/api$/.test(u) ? u : `${u}/api`;
  }
  function getUrlParam(name) {
    try { const sp = new URLSearchParams(location.search); return sp.get(name) || ''; } catch (_) { return ''; }
  }
  let API_BASE = (() => {
    const override = getUrlParam('jdgm_api_base') || getUrlParam('api') || (window.JDGM_GRID_API_BASE || '');
    const norm = normalizeApiBase(override);
    return norm || '/api';
  })();
  const DEBUG = (() => {
    try {
      const sp = new URLSearchParams(location.search);
      const v = (sp.get('jdgm_debug') || sp.get('debug') || '').toLowerCase();
      return ['1', 'true', 'yes', 'on'].includes(v);
    } catch (_) { return false; }
  })();

  function boolAttr(v, def) {
    if (v === undefined) return !!def;
    const s = String(v).toLowerCase().trim();
    if (s === '1' || s === 'true' || s === 'yes' || s === 'on') return true;
    if (s === '0' || s === 'false' || s === 'no' || s === 'off') return false;
    // Empty string from present-but-empty attribute should NOT auto-true; fall back to default
    if (s === '') return !!def;
    return false;
  }

  function filledStar() {
    return `<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>`;
  }
  function emptyStar() {
    return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" xmlns="http://www.w3.org/2000/svg"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>`;
  }

  function stars(rating) {
    const val = Math.max(0, Math.min(5, parseFloat(rating) || 0));
    let html = '';
    for (let i = 1; i <= 5; i++) {
      const fill = Math.max(0, Math.min(1, val - (i - 1))); // 0..1
      const pct = Math.round(fill * 100);
      html += `<span class="jdgm-star" aria-hidden="true"><span class="jdgm-star-empty">${emptyStar()}</span><span class="jdgm-star-fill" style="width:${pct}%">${filledStar()}</span></span>`;
    }
    return `<div class="jdgm-stars" aria-label="${val.toFixed(1)} out of 5 stars">${html}</div>`;
  }

  function mediaHtml(m) {
    if (!m) return '';
    if (m.type === 'video') {
      const poster = m.thumbnail || '';
      return `<div class="jdgm-media"><video controls preload="metadata" ${poster ? `poster='${escapeHtml(poster)}'` : ''} src="${escapeHtml(m.url)}"></video><span class="jdgm-video-badge">Video</span></div>`;
    }
    return `<div class="jdgm-media"><img loading="lazy" src="${escapeHtml(m.url)}" alt="Customer media"/></div>`;
  }

  function cardHtml(r, opts) {
    // Gate media usage strictly by upstream has_published_* when available
    const media0 = (Array.isArray(r.media) && r.media.length) ? r.media[0] : r.pictures?.[0] || null;
    if (!media0 && r.picture && r.picture.urls) {
      // Handle alternative Judge.me format
      const m = { url: r.picture.urls.original };
      // media0 = m; // Re-assigning if needed
    }

    const flagsKnown = (r.has_published_pictures !== undefined) || (r.has_published_videos !== undefined);
    const flagsAllowMedia = (r.has_published_pictures === true) || (r.has_published_videos === true);
    const m = flagsKnown ? (flagsAllowMedia ? media0 : null) : media0;

    // Resolve product context for title/link (no fallback image rendering)
    const fp = opts.fallbackProduct || {};
    let pTitle = '', pVariant = '', pUrl = '';
    if ((opts.all || opts.isFallback) && r.product) {
      pTitle = r.product.title || '';
      pVariant = r.product.variant_title || r.variant_title || '';
      if (r.product.url) pUrl = r.product.url;
      else if (r.product.handle && opts.shopDomain) { pUrl = `https://${opts.shopDomain}/products/${r.product.handle}`; }
    } else {
      pTitle = fp.title || '';
      pVariant = fp.variant || '';
      pUrl = fp.url || '';
    }
    const prodLine = pTitle ? `<div class='jdgm-prodline'><a href='${escapeHtml(pUrl || '#')}' target='_top' rel='noopener'>${escapeHtml(pTitle)}${pVariant ? ` — ${escapeHtml(pVariant)}` : ''}</a></div>` : '';

    const title = (opts.showTitle && r.title) ? `<div class='jdgm-title'>${escapeHtml(r.title)}</div>` : '';
    const body = r.body ? `<div class='jdgm-text'>${escapeHtml(truncate(r.body, 220))}</div>` : '';
    const rating = opts.showStars ? stars(r.rating) : '';
    const author = (opts.showAuthor && r.author) ? `<div class='jdgm-author'>${escapeHtml(r.author)}</div>` : '';
    let media = '';
    if (m) {
      media = mediaHtml(m);
    }
    const fallbackBadge = opts.isFallback ? `<div class="jdgm-fallback-badge">Store Review</div>` : '';
    return `<article class="jdgm-card">${media}<div class="jdgm-body">${fallbackBadge}${rating}${prodLine}${title}${body}${author}</div></article>`;
  }

  function escapeHtml(s) {
    return (s || '').replace(/[&<>"']/g, (m) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    })[m]);
  }
  function truncate(s, n) { if (!s) return s; return s.length > n ? s.slice(0, n - 1) + '…' : s; }

  function ctaHtml(href) {
    const target = href || '#judgeme_product_reviews';
    return `<div class="jdgm-cta-wrap"><a class="jdgm-cta" href="${escapeHtml(target)}">Review this product</a></div>`;
  }

  async function fetchPage({ apiBase, apiToken, productId, shopDomain, page, perPage, all, filterMode, forceKey }) {
    const isDirectJudgeme = apiBase.includes('judge.me');
    let base = apiBase;

    // Normalize base URL
    if (base.endsWith('/')) base = base.slice(0, -1);

    let path = '';
    if (isDirectJudgeme) {
      path = '/reviews';
    } else {
      path = all ? '/reviews/all' : '/reviews';
    }

    let params = new URLSearchParams({
      page: page,
      per_page: perPage
    });

    if (shopDomain) params.set('shop_domain', shopDomain);
    if (apiToken) params.set('api_token', apiToken);

    // Some proxies (like the current Render one) REQUIRE product_id for /reviews
    // but might not support it for /reviews/all
    if (!all && productId) {
      params.set('product_id', productId);
    }

    if (forceKey) params.set('force_key', forceKey);
    if (DEBUG) params.set('debug', '1');

    const url = `${base}${path}?${params.toString()}`;
    try { console.info('[JDGM] GET', url); } catch (_) { }

    const res = await fetch(url);
    let json = null;
    try { json = await res.json(); } catch (_) { /* non-JSON error */ }

    if (!res.ok) {
      const msg = (json && (json.error || json.detail)) || res.statusText || 'Failed to fetch reviews';
      const err = new Error(msg);
      try { err.status = res.status; err.payload = json; } catch (_) { }
      throw err;
    }

    // Normalize Judge.me response if needed
    // Judge.me usually returns { "reviews": [...] }

    try {
      const n = (json && json.reviews && json.reviews.length) || 0;
      console.info('[JDGM] Reviews returned:', n);
    } catch (_) { }
    return json;
  }

  function init(container) {
    const productId = container.dataset.productId;
    const shopDomain = container.dataset.shopDomain || undefined;
    const apiToken = container.dataset.apiToken || undefined;
    const perPage = parseInt(container.dataset.perPage || '12', 10);
    const allAttr = boolAttr(container.dataset.all, false);
    const initialSplit = boolAttr(container.dataset.splitReviews, false) && productId && !allAttr;
    const initialAll = productId ? false : allAttr;
    const showStars = boolAttr(container.dataset.showStars, true);
    const showTitle = boolAttr(container.dataset.showTitle, true);
    const showAuthor = boolAttr(container.dataset.showAuthor, false);
    const filterMode = (container.dataset.filter || 'media_or_text').toLowerCase();
    const infinite = boolAttr(container.dataset.infinite, false);
    const containerBase = container.dataset.apiBase || '';
    const apiBase = containerBase ? normalizeApiBase(containerBase) : API_BASE;
    const forceKey = (container.dataset.forceKey || '').trim();

    const rootWrap = document.createElement('div');
    rootWrap.className = 'jdgm-grid-wrap';
    if (container.dataset.accent) rootWrap.style.setProperty('--jdgm-accent', container.dataset.accent);
    if (container.dataset.ctaBg) rootWrap.style.setProperty('--jdgm-cta-bg', container.dataset.ctaBg);
    if (container.dataset.ctaText) rootWrap.style.setProperty('--jdgm-cta-text', container.dataset.ctaText);
    container.appendChild(rootWrap);

    // Common toolbar (optional, hide in split mode to avoid confusion)
    const toolbar = document.createElement('div');
    toolbar.className = 'jdgm-toolbar';
    if (initialSplit) toolbar.style.display = 'none';
    rootWrap.appendChild(toolbar);

    // Modular Grid Area Creator
    function createGridArea(titleText, isSitewide) {
      const area = document.createElement('div');
      area.className = 'jdgm-grid-area';

      if (titleText) {
        const header = document.createElement('div');
        header.className = 'jdgm-split-header';
        header.innerHTML = `<h3>${escapeHtml(titleText)}</h3>`;
        area.appendChild(header);
      }

      const grid = document.createElement('div');
      grid.className = 'jdgm-masonry';
      area.appendChild(grid);

      const controls = document.createElement('div');
      controls.className = 'jdgm-controls';
      const loader = document.createElement('div');
      loader.className = 'jdgm-loader';
      loader.textContent = 'Loading reviews…';
      loader.style.display = 'none';
      const moreBtn = document.createElement('button');
      moreBtn.className = 'jdgm-more-btn';
      moreBtn.textContent = 'Load more';

      controls.appendChild(loader);
      controls.appendChild(moreBtn);
      area.appendChild(controls);

      return { area, grid, loader, moreBtn, page: 1, done: false, loading: false, isSitewide };
    }

    const areas = [];
    if (initialSplit) {
      areas.push(createGridArea('Reviews of this product', false));
      areas.push(createGridArea('Reviews of our shop', true));
    } else {
      areas.push(createGridArea('', initialAll));
    }

    areas.forEach(a => rootWrap.appendChild(a.area));

    async function loadArea(areaObj) {
      if (areaObj.loading || areaObj.done) return;
      areaObj.loading = true;
      const isInitial = (areaObj.page === 1);

      if (!isInitial) {
        areaObj.moreBtn.disabled = true;
        areaObj.moreBtn.innerHTML = '<span class="jdgm-spinner"></span> Fetching more reviews...';
      }
      areaObj.loader.style.display = 'block';

      try {
        const data = await fetchPage({
          apiBase, apiToken, productId, shopDomain,
          page: areaObj.page, perPage,
          all: areaObj.isSitewide,
          filterMode, forceKey
        });

        let list = data.reviews || [];
        // Filtering & Expansion logic
        const mediaAllowed = (r) => {
          const ms = Array.isArray(r.media) ? r.media : (r.pictures || []);
          const fK = (r.has_published_pictures !== undefined) || (r.has_published_videos !== undefined);
          const fA = (r.has_published_pictures === true) || (r.has_published_videos === true);
          return fK ? (fA && ms.length > 0) : (ms.length > 0);
        };
        if (filterMode === 'media_only') list = list.filter(r => mediaAllowed(r));
        else if (filterMode === 'text_only') list = list.filter(r => r.body && r.body.trim() !== '');

        if (list.length === 0) {
          areaObj.done = true;
          if (isInitial) {
            areaObj.area.style.display = 'none';
            // Fallback integration: If this was the ONLY grid and it's empty, we might need a Store fallback
            if (areas.length === 1 && !areaObj.isSitewide) {
              // Convert current area to sitewide and re-run once
              areaObj.isSitewide = true;
              areaObj.area.style.display = 'block';
              areaObj.loading = false;
              loadArea(areaObj);
              return;
            }
          } else {
            areaObj.moreBtn.textContent = 'No more reviews';
            areaObj.moreBtn.disabled = true;
          }
          areaObj.loader.style.display = 'none';
          return;
        }

        const frag = document.createDocumentFragment();
        list.forEach(r => {
          const div = document.createElement('div');
          div.innerHTML = cardHtml(r, {
            showStars, showTitle, showAuthor,
            all: areaObj.isSitewide, isFallback: false, shopDomain,
            fallbackProduct: {
              title: container.dataset.productTitle,
              url: container.dataset.productUrl,
              variant: container.dataset.variantTitle
            }
          });
          frag.appendChild(div.firstChild);
        });
        areaObj.grid.appendChild(frag);
        areaObj.page += 1;
        areaObj.moreBtn.disabled = false;
        areaObj.moreBtn.textContent = 'Load more';
        areaObj.loader.style.display = 'none';

      } catch (e) {
        areaObj.loader.textContent = 'Error loading reviews';
        areaObj.moreBtn.textContent = 'Error';
        areaObj.done = true;
      } finally {
        areaObj.loading = false;
      }
    }

    // Attach listeners
    areas.forEach(a => {
      a.moreBtn.addEventListener('click', () => loadArea(a));
      if (infinite) {
        const obs = new IntersectionObserver(entries => {
          if (entries[0].isIntersecting) loadArea(a);
        }, { rootMargin: '600px' });
        obs.observe(a.moreBtn);
      }
    });

    // Start loading
    if (initialSplit) {
      // Load product reviews first
      loadArea(areas[0]).then(() => {
        // Only load store reviews if product reviews found, OR if you want them always?
        // User said: "2 review containers if the product has reviews already."
        // If product has reviews, areas[0].area is visible.
        if (areas[0].area.style.display !== 'none') {
          loadArea(areas[1]);
        } else {
          // If product empty, Areas[0] is hidden. We MUST show Areas[1].
          areas[1].area.querySelector('.jdgm-split-header')?.remove(); // Clean up header if it's the only one
          loadArea(areas[1]);
        }
      });
    } else {
      loadArea(areas[0]);
    }
  }

  function autoInit() {
    document.querySelectorAll('[data-jdgm-grid]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', autoInit);
  else autoInit();
})();
